import {ChatService} from '../chat.service';
import {Injectable, OnDestroy} from '@angular/core';
import {Router} from '@angular/router';
import { debounceTime } from 'rxjs/operators';
import { DomManipulationService } from '../dom-manipulation/dom-manipulation.service';
import { ASKAVENUE_SCRIPT } from '../../classes/dynamicScripts';
import { timer, Subscription } from 'rxjs';
import {environment} from '../../../environments/environment-wrapper';
import {Agent} from '../../classes/agent';

export const AVENUE_CONTAINER = 'avenue-container';

@Injectable()
export class BrowserChatService extends ChatService implements OnDestroy {
  waitPeriodSubscription;

  temporaryAgentIds = [1002, 1003, 1004, 1005];

  private initialized: boolean;

  private routerSub: Subscription;

  constructor(
    private router: Router,
    private _domManipulationService: DomManipulationService,
  ) {
    super();
    // whenever we navigate away, we need to remove the widget
    this.routerSub = this.router.events.pipe(debounceTime(50)).subscribe((s) => {
      this.removeWidget();
    });
  }

  ngOnDestroy() {
    if (this.routerSub) this.routerSub.unsubscribe();
  }

  // the css is only loaded once
  initialize() {
    const css = document.createElement('style');
    css.type = 'text/css';
    css.id = 'ask_avenue_widget_st_content';
    document.getElementsByTagName('head')[0].appendChild(css);
    this.initialized = true;
  }

  /**
   * Set up the Ask Avenue Widget. If the listing is not connected to a listing, we need to set the lat and long values along with radius and max agent
   * @param agent
   * @param latitude
   * @param longitude
   */
  setAgent(agent: Agent, latitude?: number, longitude?: number) {
    const agentId = agent ? (agent.sourceSystem.match('iFranchise-OA') ? agent.sourceSystemId : agent.personifyId) : '';
    setTimeout(() => {
      if (!this.isInitialized()) {
        this.initialize();
      }

      this.removeWidget();
      this.waitPeriodSubscription = timer(5000).subscribe(() => {
        // we just add the widget to the head when the agent id is passed in
        window.url = 'https://apiv2.askavenue.com/';
        window.scope = {
          avenueValues: {
            brokerage_uuid: environment.brokerageUUID,
            agent_id: environment.testChatUsers ? this.temporaryAgentIds[Math.floor(Math.random() * 4)] : agentId,
            max_agents: 10,
            latitude: latitude,
            longitude:  longitude,
            radius_limit: 5
          }
        };
        this._domManipulationService.loadScript(ASKAVENUE_SCRIPT);
      });
    }, 500);
  }

  // this means the css has been loaded
  public isInitialized(): boolean {
    return this.initialized;
  }

  /**
   * every page load we need to remove the object from the dom and re-add it with the new agent ID
   * the current implementation of ask avenue widget doesn't allow us to just update the agent id
   */
  removeWidget() {
    if (this.waitPeriodSubscription) { this.waitPeriodSubscription.unsubscribe(); }
    // if the widget script is already there, we remove it // kinda dumb but there's no way to update the agent id without reloading the script
    this._domManipulationService.removeElementById(ASKAVENUE_SCRIPT.id)
    // also remove the widget container
    this._domManipulationService.removeElementById(AVENUE_CONTAINER);
  }
}
